const STORAGE_KEY = 'orders_state';

/**
 * Сохраняет состояние списка заявок в LocalStorage.
 * @param {object} state - Объект с состоянием (фильтры, сортировка, количество).
 */
export function saveState(state) {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(STORAGE_KEY, serializedState);
  } catch (e) {
    console.error("Ошибка сохранения состояния в LocalStorage:", e);
  }
}

/**
 * Загружает состояние списка заявок из LocalStorage.
 * @returns {object|null} - Возвращает объект состояния или null, если ничего не найдено.
 */
export function loadState() {
  try {
    const serializedState = localStorage.getItem(STORAGE_KEY);
    if (serializedState === null) {
      return null; // Нет сохраненного состояния
    }
    return JSON.parse(serializedState);
  } catch (e) {
    console.error("Ошибка загрузки состояния из LocalStorage:", e);
    return null;
  }
}

/**
 * Очищает сохраненное состояние из LocalStorage.
 */
export function clearState() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error("Ошибка очистки состояния в LocalStorage:", e);
  }
}
